// Home.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function Home(){

  const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
  const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
  const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
  const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

  const navigate = useNavigate();

  const dispatch = useDispatch(); // dispatch(
  // const confirmedBookChapterList = useSelector((state) => state.home.confirmedBookChapterList);
  const loading4Home = useSelector((state) => state.home.loading4Home);
  const bookList = useSelector((state) => state.home.bookList);
  //const open2 = useSelector((state) => state.home.open2);
  const viewArea = useSelector((state) => state.home.viewArea);
  const circularProgressText = useSelector((state) => state.home.circularProgressText);  
  const debug = useSelector((state) => state.home.debug);  
  const userListItem = useSelector((state) => state.home.userListItem);
  const open1 = useSelector((state) => state.chapter.open1);
  const open3 = useSelector((state) => state.verseSearch.open3);  
  const credential = useSelector((state) => state.signIn.credential);
  const tabVerseListNew = useSelector((state) => state.verse.tabVerseListNew);
  const searchScopeList = useSelector((state) => state.verseSearch.searchScopeList);
  const noteBookmarkListBookChapterVerse = useSelector((state) => state.noteBookmarkList.noteBookmarkListBookChapterVerse);
  
  const handleOnClickClear = () => {
    deleteLogListItem();
  }

  // const handleDialogClose4 = () => {
  //   dispatch(setOpen4(false));
  // }

  const handleDialogClose3 = () => {
      dispatch(setOpen3(false));
  }

  const handleDialogClose1 = (e) => {
    dispatch(setOpen1(false));
  }

  const handleCopy = (e) => {

    let resultList = [];

    for (let i = 0; i < 4; i++) {
      let book = tabVerseListNew[i].book;
      let chapter = tabVerseListNew[i].chapter;
      if (book > 0 && chapter > 0) {
        for (let j = 0; j < tabVerseListNew[i].verses.length; j++) {
          let selected = tabVerseListNew[i].verses[j].selected; 
          if (selected) {
            let details = tabVerseListNew[i].verses[j].details;
            let result = {book: book, chapter: chapter, verse: j+1, details: details};
            if (canPushNewEntry(resultList, result)) {
              resultList.push(result);
            }            
          }
        }
      }
    }
    resultList = sortResultList(resultList);

    let textToCopy = '';

    if (resultList.length > 0) {

      textToCopy = resultList[0].details;

      let book = resultList[0].book;
      let chapter = resultList[0].chapter;
      let verseRange = {book: book, chapter: chapter, verseStart: resultList[0].verse, verseEnd: resultList[0].verse};

      for (let i = 1; i < resultList.length; i++) {
        if (resultList[i].book === resultList[i-1].book && resultList[i].chapter === resultList[i-1].chapter && resultList[i].verse === resultList[i-1].verse+1) {
          textToCopy = `${textToCopy}${resultList[i].details}`;
          verseRange = {...verseRange, verseEnd: resultList[i].verse};
        } else {
          textToCopy = `${textToCopy} (${verseRangeChineseName(bookList, verseRange)})\n${resultList[i].details}`;
          verseRange = {book: resultList[i].book, chapter: resultList[i].chapter, verseStart: resultList[i].verse, verseEnd: resultList[i].verse}
        }
      }   
      textToCopy = `${textToCopy} (${verseRangeChineseName(bookList, verseRange)})\n`;

    }

    window.focus();
    navigator.clipboard.writeText(textToCopy).then(() => {

    }).catch(err => {
      console.error('Failed to copy: ', err);
    });

    const list = resetSelectedAll(tabVerseListNew);
    dispatch(setTabVerseListNew(list));
    
  };

  const handleNote = (e) => {
    if (e === true) {
      dispatch(setConfirmedTabNumber(-1));
      dispatch(setViewArea('Note'));
    }
  };

  const handleSearch = (e) => {
    if (e === true) {
      if (searchScopeList.length === 0) getSearchScopeList('Home');
      dispatch(setConfirmedTabNumber(-1));
      dispatch(setViewArea('VerseSearch'));
    }
  };

  useEffect(() => {
    if (credential === null) {
      navigate('/signin');
    }
    if (bookList.length === 0) {
      getBookList('Home');
    }
    if (userListItem === null) {
      getUserListItem('Home');
    }
  }, []);

  return (
  
    <div>

      <Navbar />

      <div style={{ paddingTop: '50px' }}>

        <searchContext.Provider value={{ handleSearch }}>
        <noteContext.Provider value={{ handleNote }}>
        <homeContext.Provider value={{ handleCopy }}>

          <Container sx={{ mt: 4, mb: 4 }}>
            {/* {credential.UserName}     */}
            <Grid xs={12}>
              <Selection />
            </Grid> 

            <Grid container spacing={1}>

              <Grid size={12}>
                <Tab1 />
              </Grid>
  
              {/* {userListItem &&
                <div style={{ display: debug ? 'block' : 'none' }}>
                  <Grid xs={12}>
                    <IconButton
                        sx={{
                            borderRadius: 1,
                            bgcolor: 'error.main',
                            '&:hover': { bgcolor: 'error.main' },
                            
                        }}
                        onClick={handleOnClickClear}
                    >
                        <CloseIcon sx={{ color: 'white' }} />
                    </IconButton> 
                    <Typography variant='body2'>
                      {circularProgressText}
                    </Typography>
                  </Grid>
                </div>
              } */}

              <Grid size={12}>

                <div style={{ display: viewArea === 'Tab0' ? 'block' : 'none' }}>
                  {tabVerseListNew[0].book > 0 && tabVerseListNew[0].chapter > 0 && <Verse tabNumber={0}/>}
                </div>
                
                <div style={{ display: viewArea === 'Tab1' ? 'block' : 'none' }}>
                  {tabVerseListNew[1].book > 0 && tabVerseListNew[1].chapter > 0 && <Verse tabNumber={1}/>}
                </div>

                <div style={{ display: viewArea === 'Tab2' ? 'block' : 'none' }}>
                  {tabVerseListNew[2].book > 0 && tabVerseListNew[2].chapter > 0 && <Verse tabNumber={2}/>}
                </div>        

                <div style={{ display: viewArea === 'Tab3' ? 'block' : 'none' }}>
                  {tabVerseListNew[3].book > 0 && tabVerseListNew[3].chapter > 0 && <Verse tabNumber={3}/>}            
                </div>

                <div style={{ display: viewArea === 'VerseSearch' ? 'block' : 'none' }}>
                  <VerseSearch />
                </div>

                <div style={{ display: viewArea === 'Note' ? 'block' : 'none' }}>
                  {noteBookmarkListBookChapterVerse.book > 0 &&
                    <NoteBookmarkList caller={'Note'}/>
                  }
                </div>                

              </Grid>

            </Grid>

            <Dialog open={open1}>
              <DialogTitle>
                選擇經文顯示區
                <IconButton style={{ position: 'absolute', right: 1, top: 1 }} onClick={handleDialogClose1}>
                  <CloseIcon />
                </IconButton>         
              </DialogTitle>

              <DialogContent sx={{ marginTop: 2 }}>
                <Dialog1 
                  handleDialogClose1={handleDialogClose1} 
                />
              </DialogContent>

            </Dialog>

            {/* <Dialog open={open2}>

              <DialogTitle>
                讀經歷史
                <IconButton style={{ position: 'absolute', right: 1, top: 1 }} onClick={handleDialogClose2}>
                  <CloseIcon />
                </IconButton>          
              </DialogTitle>

              <DialogContent sx={{ marginTop: 2 }}>
                <Dialog2 
                  handleDialogClose2={handleDialogClose2} 
                />
              </DialogContent>

            </Dialog>  */}

            <Dialog open={open3}>

              <DialogTitle>
                選擇經文顯示區
                  <IconButton style={{ position: 'absolute', right: 1, top: 1 }} onClick={handleDialogClose3}>
                      <CloseIcon />
                  </IconButton>         
              </DialogTitle>

              <DialogContent sx={{ marginTop: 2 }}>
                  <Dialog3 handleDialogClose3={handleDialogClose3}/>
              </DialogContent>

            </Dialog>         

          </Container>

        </homeContext.Provider>
        </noteContext.Provider>
        </searchContext.Provider>

      </div>

      {/* {loading4Home && <ClipLoader1 />} */}

      <ConfirmationDialog />

    </div>

  )

}